import HomeHeroEditor from "./HomeHeroEditor";
import MarqueeEditor from "./MarqueeEditor";
import HomeCTAsEditor from "./HomeCTAsEditor";
import SeoGlobalEditor from "./SeoGlobalEditor";
import SeoPagesEditor from "./SeoPagesEditor";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "./ui/tabs";

/**
 * Wraps the editable home-page blocks + site-wide SEO settings under one
 * tab, with sub-tabs for each block. Reused from both the admin and the
 * assistant dashboards.
 */
export default function HomePageCMS() {
  return (
    <div data-testid="home-page-cms">
      <Tabs defaultValue="hero">
        <TabsList className="flex-wrap h-auto">
          <TabsTrigger value="hero" data-testid="home-cms-tab-hero">Bloc Édition limitée</TabsTrigger>
          <TabsTrigger value="marquee" data-testid="home-cms-tab-marquee">Bandeau défilant</TabsTrigger>
          <TabsTrigger value="ctas" data-testid="home-cms-tab-ctas">Healthy Guides & Kitchen Corner</TabsTrigger>
          <TabsTrigger value="seo-global" data-testid="home-cms-tab-seo-global">SEO global</TabsTrigger>
          <TabsTrigger value="seo-pages" data-testid="home-cms-tab-seo-pages">SEO par page</TabsTrigger>
        </TabsList>
        <TabsContent value="hero" className="mt-6">
          <HomeHeroEditor />
        </TabsContent>
        <TabsContent value="marquee" className="mt-6">
          <MarqueeEditor />
        </TabsContent>
        <TabsContent value="ctas" className="mt-6">
          <HomeCTAsEditor />
        </TabsContent>
        <TabsContent value="seo-global" className="mt-6">
          <SeoGlobalEditor />
        </TabsContent>
        <TabsContent value="seo-pages" className="mt-6">
          <SeoPagesEditor />
        </TabsContent>
      </Tabs>
    </div>
  );
}
